module.exports = __webpack_public_path__ + "img/nature-65.1403ebf9.jpg";